import React from "react";
import { useSelector } from "react-redux";
import qs from "query-string";
import DateFilterWrap from "components/DateFilter/wrap";
import get from "lodash/get";
import dayjs from "dayjs";
import useTranslation from "hooks/useTranslation";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "services/api";
import Spinner from "components/Spinner";
import TableRestaurantInventoryMetrics from "pages/Main/Storage/components/TableRestaurantInventoryMetrics";
import SelfLeftovers from "./self-leftovers";
import useMainOrganization from "hooks/useMainOrganization";

const InventoryMetrics = ({
	filialLeftover,
	index,
	currency,
	onStorageClick = () => { }
}) => {
	const { tr } = useTranslation();
	return (
		<div className="bg-gray-100 overflow-hidden !rounded-md !border-4 !border-gray-900">
			<div className="bg-gray-200 p-3 border-b border-gray-300 border-l-4 border-l-blue-500">
				<h3 className="mb-0 text-xl font-medium">
					{index + 1}. {get(filialLeftover, "name")}
				</h3>
			</div>

			<div className="py-5 px-7">
				<TableRestaurantInventoryMetrics
					data={filialLeftover}
					title={tr("Остаток")}
					currency={currency}
					type="filialLeftover"
					onStorageClick={onStorageClick}
				/>
			</div>
		</div>
	);
};

function MainOrganizationStorageLeftovers({ isMainPage = false }) {
	const location = useLocation();
	const { tr } = useTranslation();
	const navigate = useNavigate();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });
	const default_currency_code = useSelector(
		state => state.auth.default_currency_code
	);
	const currency = default_currency_code && default_currency_code.toUpperCase();

	const startAt =
		query.start_at ||
		dayjs()
			.startOf("day")
			.unix();
	const endAt =
		query.end_at ||
		dayjs()
			.endOf("day")
			.unix();

	const onStorageClick = storage => {
		navigate({
			pathname: `/storages/${storage.id}/`
		});
	};

	const queryStorageLeftovers = useQuery({
		queryKey: ["queryStorageLeftovers", startAt, endAt],
		queryFn: () =>
			api.request({
				url: "/main/reports/storages",
				params: {
					sort: "id",
					limit: 100,
					start_at: startAt,
					end_at: endAt
				}
			})
	});

	const mainOrganization = useMainOrganization();
	const filialsLeftovers = get(queryStorageLeftovers, "data.data", []).filter(
		item => {
			if (isMainPage) return true;

			return String(item.id) !== String(get(mainOrganization, "id"));
		}
	);

	if (queryStorageLeftovers.status === "loading") {
		return (
			<div className="flex justify-center items-center h-[300px]">
				<Spinner />
			</div>
		);
	}

	return (
		<div>
			{isMainPage ? null : (
				<>
					<div className="flex items-center gap-5 mb-20">
						<DateFilterWrap
							initialDefault={"day"}
							withStartHoursAppended={true}
							navigateByDay={true}
						/>
						<h3 className="my-0 font-bold text-xl">{tr("Остаток")}</h3>
					</div>

					<SelfLeftovers />

					<div className="h-[30px]" />
				</>
			)}

			<div className={isMainPage ? "" : "d-panel"}>
				<div className="d-flex align-items-center justify-content-between mb-10">
					<div className="main-title">{tr("Остатки (филиалы)")}</div>
				</div>

				<div className="grid grid-cols-1 gap-10">
					{filialsLeftovers.map((filialLeftover, idx) => (
						<InventoryMetrics
							index={idx}
							key={idx}
							filialLeftover={filialLeftover}
							currency={currency}
							onStorageClick={onStorageClick}
						/>
					))}
				</div>
			</div>
		</div>
	);
}

export default MainOrganizationStorageLeftovers;
